export default __webpack_public_path__ + "static/media/pic1-main.a67ecfb2.jpeg";